export default __webpack_public_path__ + "static/media/jan2.1c0e3122.jpg";